import React from 'react';

function Images({ size, ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...otherProps}
    >
      <rect x="3" y="3" width="15" height="15" rx="2" />
      <path d="M7.89 9.22a1.33 1.33 0 100-2.66 1.33 1.33 0 000 2.66z" />
      <path d="M18 13.1L13.94 9 5 18" />
      <path d="M5.5 20.5h11a4 4 0 004-4V6" />
    </svg>
  );
}

export default Images;
